import { combineReducers, compose, createStore as _createStore, Reducer, StoreEnhancer } from 'redux';
import { documentReducer, linksReducer } from '../../reducers';
import { IApplicationState, TReduxActions, TReduxStore } from '../../types/redux';

let storeReminder: TReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 * @param debugEnabled boolean
 */
export function createReduxStore(initialState: IApplicationState, debugEnabled: boolean) {
  const reducers = combineReducers({
    document: documentReducer,
    links: linksReducer,
  }) as unknown as Reducer<IApplicationState, TReduxActions>;

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers() as StoreEnhancer;

  const createStore = (): TReduxStore => _createStore(reducers, initialState, storeEnchancers);

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
